import styled from 'styled-components';
import { Hint, ButtonV2 } from '@getgrover/ui';

export const Button = styled(ButtonV2)`
    margin-top: 16px;
`;

export const ButtonText = styled.h3`
    ${({ theme }) => theme.typography.SuperTinyHeadline};
`;

export const Warning = styled(Hint)`
    margin-top: 16px;
`;
